import React, { useState, useCallback, useEffect, useRef } from "react";
import ReactModal from "react-modal";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  LoginOtp,
  SetLoginModalOpen,
  authActions,
  loginAuthentication,
  setLoginMobile,
} from "../../redux/authentication/AuthenticationSlice";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
ReactModal.setAppElement("#root");

const CONSTANTS = {
  OTP_LENGTH: 6,
  PHONE_LENGTH: 10,
  MODAL_STYLES: {
    login: {
      content: {
        width: "90%",
        maxWidth: "400px",
        height: "30vh",
        minHeight: "285px",
        overflow: "hidden",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        borderRadius: "8px",
      },
      overlay: {
        background: "rgba(0,0,0,0.6)",
        zIndex: "1000",
      },
    },
    otp: {
      content: {
        width: "90%",
        maxWidth: "400px",
        height: "auto",
        minHeight: "350px",
        overflow: "hidden",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        borderRadius: "8px",
      },
      overlay: {
        background: "rgba(0,0,0,0.6)",
        zIndex: "1000",
      },
    },
    register: {
      content: {
        width: "90%",
        maxWidth: "400px",
        height: "auto",
        minHeight: "400px",
        overflow: "hidden",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        borderRadius: "8px",
      },
      overlay: {
        background: "rgba(0,0,0,0.6)",
        zIndex: "1000",
      },
    },
  },
};

const Login = () => {
  const authState = useSelector((store) => ({
    isAuth: store.Authentication.isAuth,
    loginData: store.Authentication.loginData,
    loginMobile: store.Authentication.loginMobile,
    isLoginModalOpen: store.Authentication.isLoginModalOpen,
    mob: store.Authentication.mob,
    otp: store.Authentication.otp,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modals, setModals] = useState({
    otp: false,
    register: false,
  });

  const [formData, setFormData] = useState({
    number: "",
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    otp6: "",
    name: "",
    email: "",
    termCheckbox: false,
  });

  const [uiState, setUiState] = useState({
    seconds: 30,
    isActive: false,
    errorMessage: "",
    errorColor: "#FF3B30",
    loginbtnLoad: false,
    otpbtnLoad: false,
    nameError: "",
    emailError: "",
    userExists: false,
  });

  // Refs for OTP inputs
  const otpRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];

  // Debug localStorage on component mount
  useEffect(() => {
    console.log("🔍 Checking localStorage on Login component mount:");
    const savedAuthData = localStorage.getItem("authState");
    console.log("LocalStorage authState:", savedAuthData);
    if (savedAuthData) {
      try {
        const parsedData = JSON.parse(savedAuthData);
        console.log("Parsed auth data:", parsedData);
        console.log(
          "Is user authenticated in localStorage?",
          parsedData.isAuth
        );
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }
    }
  }, []);

  // Effects
  useEffect(() => {
    let interval = null;
    if (uiState.isActive && uiState.seconds > 0) {
      interval = setInterval(() => {
        setUiState((prev) => ({ ...prev, seconds: prev.seconds - 1 }));
      }, 1000);
    } else if (uiState.seconds === 0) {
      setUiState((prev) => ({ ...prev, isActive: false }));
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [uiState.isActive, uiState.seconds]);

  // Check if user exists
  const checkUserExists = useCallback(async (mobileNumber) => {
    try {
      const response = await axios.get(
        `${Baseurl}/api/v1/client/mobile/${mobileNumber}`
      );
      console.log("User exists API response:", response.data);
      return response.data.success;
    } catch (error) {
      console.log("User check error:", error);
      if (error.response?.status === 404) {
        return false;
      }
      return false;
    }
  }, []);

  // Generate OTP
  const generateOTP = () => {
    const digits = "0123456789";
    let OTP = "";
    for (let i = 0; i < 6; i++) {
      OTP += digits[Math.floor(Math.random() * 10)];
    }

    // Special OTP for test numbers
    if (formData.number === "9908018294" || formData.number === "8018582135") {
      OTP = "111111";
    }

    return OTP;
  };

  // Login handler
  const handleLoginSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (formData.number.length !== CONSTANTS.PHONE_LENGTH) {
        setUiState((prev) => ({
          ...prev,
          errorMessage: "Please enter a valid 10-digit mobile number",
          errorColor: "#FF3B30",
        }));
        return;
      }

      if (!formData.termCheckbox) {
        setUiState((prev) => ({
          ...prev,
          errorMessage: "Please accept Terms and Conditions",
          errorColor: "#FF3B30",
        }));
        return;
      }

      setUiState((prev) => ({ ...prev, loginbtnLoad: true, errorMessage: "" }));

      try {
        // Check if user exists
        let userExists = false;
        try {
          userExists = await checkUserExists(formData.number);
          console.log("User exists check result:", userExists);
        } catch (error) {
          console.log("User check failed, assuming new user:", error);
          userExists = false;
        }

        // Generate OTP
        const OTP = generateOTP();
        console.log("Generated OTP:", OTP);

        // Prepare OTP data
        const otpData = {
          mobile: formData.number,
          otp: OTP,
        };

        // Store in Redux
        dispatch(setLoginMobile(formData.number));
        dispatch(LoginOtp({ number: formData.number, OTP: OTP }));

        // Send OTP via API
        console.log("Sending OTP request:", otpData);
        const result = await dispatch(loginAuthentication(otpData)).unwrap();
        console.log("OTP API response:", result);

        if (result.success) {
          setUiState((prev) => ({
            ...prev,
            userExists,
            seconds: 30,
            isActive: true,
            errorMessage: "",
          }));

          setModals((prev) => ({ ...prev, otp: true }));
          dispatch(SetLoginModalOpen(false));
          toast.success("OTP sent successfully!");
        } else {
          throw new Error(result.message || "Failed to send OTP");
        }
      } catch (error) {
        console.error("Login error:", error);
        setUiState((prev) => ({
          ...prev,
          errorMessage:
            error.message || "Failed to send OTP. Please try again.",
          errorColor: "#FF3B30",
        }));
        toast.error("Failed to send OTP");
      } finally {
        setUiState((prev) => ({ ...prev, loginbtnLoad: false }));
      }
    },
    [formData.number, formData.termCheckbox, dispatch, checkUserExists]
  );

  // OTP input handlers
  const handleOtpChange = (index, value) => {
    const numericValue = value.replace(/\D/g, "");
    if (numericValue === "") {
      setFormData((prev) => ({ ...prev, [`otp${index + 1}`]: "" }));
      if (index > 0) {
        otpRefs[index - 1].current.focus();
      }
      return;
    }

    const singleDigit = numericValue.slice(-1);
    setFormData((prev) => ({ ...prev, [`otp${index + 1}`]: singleDigit }));

    if (singleDigit && index < 5) {
      otpRefs[index + 1].current.focus();
    }

    const currentOtp = Object.values(formData)
      .slice(1, 7)
      .map((val, i) => (i === index ? singleDigit : val))
      .join("");

    if (currentOtp.length === 6) {
      handleVerifyOtp(currentOtp);
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !formData[`otp${index + 1}`] && index > 0) {
      otpRefs[index - 1].current.focus();
    }
  };

  // OTP verification
  const handleVerifyOtp = useCallback(
    async (otpValue = null) => {
      const finalOtp = otpValue || Object.values(formData).slice(1, 7).join("");

      if (finalOtp.length !== CONSTANTS.OTP_LENGTH) {
        setUiState((prev) => ({
          ...prev,
          errorMessage: "Please enter complete OTP",
          errorColor: "#FF3B30",
        }));
        return;
      }

      setUiState((prev) => ({ ...prev, otpbtnLoad: true, errorMessage: "" }));

      try {
        if (finalOtp === authState.otp) {
          setUiState((prev) => ({ ...prev, errorColor: "#4CAF50" }));

          const config = { headers: { "Content-Type": "application/json" } };
          const loginData = { Mobile: authState.mob };

          try {
            console.log("Attempting to login user...");
            const userDetails = await axios.post(
              `${Baseurl}/api/v1/client/loginclient`,
              loginData,
              config
            );

            if (userDetails.data.success) {
              console.log("User exists, login successful");
              const loginDetails = { ...userDetails.data.client, isAuth: true };

              // Debug before dispatching signin
              console.log("🔄 Dispatching signin with data:", loginDetails);

              dispatch(authActions.signin(loginDetails));

              // Debug after dispatching
              setTimeout(() => {
                console.log(
                  "✅ After signin - localStorage:",
                  localStorage.getItem("authState")
                );
              }, 100);

              toast.success("Logged in Successfully");
              setModals((prev) => ({ ...prev, otp: false }));
              dispatch(setLoginMobile(""));
              resetForm();
              navigate("/");
            } else {
              console.log("Login API returned success: false");
              throw new Error("Login failed");
            }
          } catch (loginError) {
            console.log("Login API error:", loginError);

            if (
              loginError.response?.status === 404 ||
              loginError.response?.data?.message?.includes("not found") ||
              loginError.response?.data?.message?.includes("not exist")
            ) {
              console.log("User not found, showing registration form");
              setModals((prev) => ({ otp: false, register: true }));
              toast.success("Please complete your registration");
            } else if (uiState.userExists) {
              console.log("User exists but login failed");
              setUiState((prev) => ({
                ...prev,
                errorMessage: "Login failed. Please try again.",
                errorColor: "#FF3B30",
              }));
              toast.error("Login failed");
            } else {
              console.log("Assuming new user, showing registration form");
              setModals((prev) => ({ otp: false, register: true }));
              toast.success("Please complete your registration");
            }
          }
        } else {
          setUiState((prev) => ({
            ...prev,
            errorMessage: "Invalid OTP. Please try again.",
            errorColor: "#FF3B30",
          }));
        }
      } catch (error) {
        console.error("OTP verification error:", error);
        setUiState((prev) => ({
          ...prev,
          errorMessage: "Verification failed. Please try again.",
          errorColor: "#FF3B30",
        }));
      } finally {
        setUiState((prev) => ({ ...prev, otpbtnLoad: false }));
      }
    },
    [
      formData,
      authState.otp,
      authState.mob,
      dispatch,
      uiState.userExists,
      navigate,
    ]
  );

  // Resend OTP
  const handleResendOtp = useCallback(async () => {
    resetOtp();
    setUiState((prev) => ({ ...prev, seconds: 30, isActive: true }));

    try {
      const OTP = generateOTP();
      const otpData = { mobile: authState.mob, otp: OTP };

      dispatch(LoginOtp({ number: authState.mob, OTP: OTP }));
      await dispatch(loginAuthentication(otpData)).unwrap();

      toast.success("OTP resent successfully!");
    } catch (error) {
      toast.error("Failed to resend OTP");
    }
  }, [dispatch, authState.mob]);

  // Registration handler
  const handleRegisterSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!formData.name.trim()) {
        setUiState((prev) => ({ ...prev, nameError: "Please provide name" }));
        return;
      }
      if (!formData.email.trim()) {
        setUiState((prev) => ({ ...prev, emailError: "Please provide email" }));
        return;
      }

      const mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (!formData.email.match(mailformat)) {
        setUiState((prev) => ({
          ...prev,
          emailError: "Please enter valid email",
        }));
        return;
      }

      try {
        const registerData = {
          Name:
            formData.name.charAt(0).toUpperCase() +
            formData.name.slice(1).toLowerCase(),
          Email: formData.email.trim(),
          Mobile: authState.mob,
        };

        const config = { headers: { "Content-Type": "application/json" } };
        const response = await axios.post(
          `${Baseurl}/api/v1/client/new`,
          registerData,
          config
        );

        if (response.data.success) {
          const loginDetails = { ...response.data.client, isAuth: true };

          // Debug registration
          console.log(
            "🔄 Registration successful, dispatching signin:",
            loginDetails
          );

          dispatch(authActions.signin(loginDetails));

          // Debug after registration
          setTimeout(() => {
            console.log(
              "✅ After registration - localStorage:",
              localStorage.getItem("authState")
            );
          }, 100);

          toast.success("Account Created Successfully");
          setModals((prev) => ({ ...prev, register: false }));
          resetForm();
          navigate("/");
        } else {
          toast.error(response.data.message || "Registration failed");
        }
      } catch (error) {
        console.error("Registration error:", error);
        toast.error("Registration failed. Please try again.");
      }
    },
    [formData, authState.mob, dispatch, navigate]
  );

  // Helper functions
  const resetForm = () => {
    setFormData({
      number: "",
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",
      name: "",
      email: "",
      termCheckbox: false,
    });
    setUiState((prev) => ({
      ...prev,
      errorMessage: "",
      nameError: "",
      emailError: "",
      seconds: 30,
      isActive: false,
      userExists: false,
    }));
  };

  const resetOtp = () => {
    setFormData((prev) => ({
      ...prev,
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",
    }));
  };

  const handleFormChange = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "name") setUiState((prev) => ({ ...prev, nameError: "" }));
    if (field === "email") setUiState((prev) => ({ ...prev, emailError: "" }));
    if (field === "termCheckbox")
      setUiState((prev) => ({ ...prev, errorMessage: "" }));
  }, []);

  const handleNumberChange = useCallback((e) => {
    const value = e.target.value.replace(/\D/g, "");
    setFormData((prev) => ({ ...prev, number: value }));
    setUiState((prev) => ({
      ...prev,
      errorMessage:
        value.length === CONSTANTS.PHONE_LENGTH
          ? ""
          : "Please Enter Valid Number",
    }));
  }, []);

  // Modal handlers
  const modalHandlers = {
    otp: {
      close: () => {
        setModals((prev) => ({ ...prev, otp: false }));
        resetOtp();
      },
    },
    register: {
      close: () => {
        setModals((prev) => ({ ...prev, register: false }));
        resetForm();
      },
    },
    login: {
      close: () => {
        dispatch(SetLoginModalOpen(false));
        resetForm();
      },
    },
  };

  // Render methods
  const renderLoginModal = () => (
    <ReactModal
      isOpen={authState.isLoginModalOpen}
      onRequestClose={modalHandlers.login.close}
      style={CONSTANTS.MODAL_STYLES.login}
    >
      <div className="rounded">
        <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
          <h5 style={{ color: "#CE665B", margin: 0 }}>Login</h5>
          <Close
            style={{ color: "#CE665B", cursor: "pointer" }}
            onClick={modalHandlers.login.close}
          />
        </div>

        <div className="mt-3">
          <div className="text-secondary mb-2 fs-6">
            Enter Your Mobile Number *
          </div>
          <div className="d-flex rounded border overflow-hidden">
            <span className="bg-light d-flex align-items-center justify-content-center px-3 border-end">
              +91
            </span>
            <input
              type="text"
              className="form-control border-0"
              placeholder="Mobile Number"
              value={formData.number}
              onChange={handleNumberChange}
              maxLength={10}
              style={{ fontSize: "14px" }}
            />
          </div>
        </div>

        {uiState.errorMessage && (
          <div
            className="mt-2"
            style={{ color: uiState.errorColor, fontSize: "12px" }}
          >
            {uiState.errorMessage}
          </div>
        )}

        <div className="d-flex align-items-center gap-2 mt-3">
          <input
            type="checkbox"
            id="termsCheck"
            checked={formData.termCheckbox}
            onChange={(e) => handleFormChange("termCheckbox", e.target.checked)}
            className="form-check-input"
            style={{
              width: "16px",
              height: "16px",
              accentColor: "#B93C5B",
              cursor: "pointer",
            }}
          />

          <label
            htmlFor="termsCheck"
            className="form-check-label mt-2"
            style={{ fontSize: "13px", cursor: "pointer" }}
          >
            I have read{" "}
            <span
              className="text-primary fw-semibold"
              style={{ textDecoration: "underline" }}
            >
              Terms and Conditions
            </span>
          </label>
        </div>

        <div className="mt-4">
          <button
            onClick={handleLoginSubmit}
            disabled={
              uiState.loginbtnLoad ||
              !formData.termCheckbox ||
              formData.number.length !== 10
            }
            className="btn text-white w-100 py-2"
            style={{
              backgroundColor:
                formData.termCheckbox &&
                formData.number.length === 10 &&
                !uiState.loginbtnLoad
                  ? "#B93C5B"
                  : "#e09faf",
              transition: "0.2s",
            }}
          >
            {uiState.loginbtnLoad ? "Sending OTP..." : "Login"}
          </button>
        </div>
      </div>
    </ReactModal>
  );

  const renderOtpModal = () => (
    <ReactModal
      isOpen={modals.otp}
      onRequestClose={modalHandlers.otp.close}
      style={CONSTANTS.MODAL_STYLES.otp}
    >
      <div className="rounded">
        <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
          <h5 style={{ color: "#CE665B", margin: 0 }}>OTP Verification</h5>
          <Close
            style={{ color: "#CE665B", cursor: "pointer" }}
            onClick={modalHandlers.otp.close}
          />
        </div>

        <div className="mt-3">
          <p className="fw-500 mb-1">Enter the code sent to your number</p>
          <p className="text-secondary small">
            Sent to <strong>+91 {authState.mob}</strong>
          </p>
        </div>

        <div className="mt-4">
          <div className="d-flex justify-content-between gap-2">
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <input
                key={index}
                ref={otpRefs[index]}
                type="text"
                maxLength={1}
                value={formData[`otp${index + 1}`]}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                className="form-control text-center"
                style={{
                  height: "50px",
                  fontSize: "18px",
                  border: `2px solid ${
                    formData[`otp${index + 1}`] ? "#B93C5B" : "#dee2e6"
                  }`,
                  backgroundColor: formData[`otp${index + 1}`]
                    ? "#f8f0f3"
                    : "#fff",
                }}
              />
            ))}
          </div>
        </div>

        {uiState.errorMessage && (
          <div className="mt-3 small" style={{ color: uiState.errorColor }}>
            {uiState.errorMessage}
          </div>
        )}

        <div className="mt-3">
          {uiState.seconds > 0 ? (
            <div className="small text-secondary">
              Didn't receive the OTP? Retry in 00:
              {uiState.seconds < 10 ? `0${uiState.seconds}` : uiState.seconds}
            </div>
          ) : (
            <div className="small">
              Didn't receive the OTP?{" "}
              <span
                className="text-primary cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={handleResendOtp}
              >
                Resend Code
              </span>
            </div>
          )}
        </div>

        <div className="mt-4">
          <button
            onClick={() => handleVerifyOtp()}
            disabled={uiState.otpbtnLoad}
            className="btn text-white w-100 py-2"
            style={{
              backgroundColor: uiState.otpbtnLoad ? "#e09faf" : "#B93C5B",
              transition: "0.2s",
            }}
          >
            {uiState.otpbtnLoad ? "Verifying..." : "Verify"}
          </button>
        </div>
      </div>
    </ReactModal>
  );

  const renderRegisterModal = () => (
    <ReactModal
      isOpen={modals.register}
      onRequestClose={modalHandlers.register.close}
      style={CONSTANTS.MODAL_STYLES.register}
    >
      <div>
        <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
          <h5 style={{ color: "#CE665B", margin: 0 }}>Create Account</h5>
          <Close
            style={{ color: "#CE665B", cursor: "pointer" }}
            onClick={modalHandlers.register.close}
          />
        </div>

        <div className="mt-3">
          <p className="fw-500 mb-3">
            Fill your information below to get started
          </p>

          <div className="mb-3">
            <label className="form-label small fw-500">Enter Your Name</label>
            <input
              type="text"
              className="form-control py-2"
              placeholder="Full name"
              value={formData.name}
              onChange={(e) => handleFormChange("name", e.target.value)}
            />
            {uiState.nameError && (
              <div className="text-danger small mt-1">{uiState.nameError}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label small fw-500">Enter Your Email</label>
            <input
              type="email"
              className="form-control py-2"
              placeholder="Email address"
              value={formData.email}
              onChange={(e) => handleFormChange("email", e.target.value)}
            />
            {uiState.emailError && (
              <div className="text-danger small mt-1">{uiState.emailError}</div>
            )}
          </div>
        </div>

        <button
          onClick={handleRegisterSubmit}
          className="btn w-100 text-white py-2"
          style={{ backgroundColor: "#B93C5B" }}
        >
          CREATE ACCOUNT
        </button>

        <div className="mt-3 text-center small">
          Already have an account?{" "}
          <span
            className="text-primary cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => {
              modalHandlers.register.close();
              dispatch(SetLoginModalOpen(true));
            }}
          >
            Sign In
          </span>
        </div>
      </div>
    </ReactModal>
  );

  return (
    <div>
      {renderLoginModal()}
      {renderOtpModal()}
      {renderRegisterModal()}
    </div>
  );
};

export default Login;
